import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class IntangibleAssets extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '无形资产';
    }
    
    getColumns = () => {
        return [{
            title: '账面价值',
            dataIndex: 'currentIntaasset'
        }, {
            title: '占总资产比例',
            dataIndex: 'totalProportion'
        }, {
            title: '较上期增加比',
            dataIndex: 'proportion'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/IntangibleAssets.jsx